module.exports = new __parcel__URL__("space_elixir_mine_level_12.c1d35ac6.png").toString();